// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/vant'
// 导入二维码组件
import VueQriously from 'vue-qriously/dist/vue-qriously'

import '@/assets/fonts/font.css'

// 导入svg-icon
// import './icons'

// 引入二维码
Vue.use(VueQriously)

// 动态标题 & favicon
const DEFAULT_TITLE = 'Philips Home Access'

function setFavicon (href) {
  document.querySelectorAll("link[rel*='icon']").forEach(link => {
    link.href = href
  })
}

router.afterEach((to) => {
  document.title = to.query.pageTitle || to.meta.title || DEFAULT_TITLE
  const host = window.location.host.toLowerCase()
  if (to.path === '/motorola' || host === 'download.aegiix.com') {
    setFavicon('/static/motorola.ico')
    document.title = 'Motorola Home Security'
  } else if (to.path === '/teeho' || host === 'download.teeho.com') {
    setFavicon('/static/teeho.ico')
    document.title = 'Teeho Home Security'
  } else {
    setFavicon('/static/favicon.ico')
  }
})

/* eslint-disable no-new */
// 实例化Vue实例
new Vue({
  // 定义Vue绑定的跟元素
  el: '#app',
  // 将上面声明的路由器传递到根Vue实例
  router,
  // 声明App组件，这样上面的<App/>元素就可以生效
  components: { App },
  // 用<App/>代替根元素
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js